'use client';

import { forwardRef } from 'react';
import MuiTypography, {
  TypographyPropsVariantOverrides,
  TypographyProps as MuiTypographyProps,
} from '@mui/material/Typography';
import { OverridableStringUnion } from '@mui/types';
import { TypographyVariant } from '../styles';

export type Props = MuiTypographyProps & { __isDangerousHtml?: boolean };
export type Variant = OverridableStringUnion<
  TypographyVariant | 'inherit',
  TypographyPropsVariantOverrides
>;

const Typography = forwardRef<HTMLElement, Props>(
  ({ __isDangerousHtml, children, ...rest }, ref) => {
    if (__isDangerousHtml) {
      return (
        <MuiTypography
          ref={ref}
          {...rest}
          dangerouslySetInnerHTML={{ __html: children as string }}
        />
      );
    }

    return (
      <MuiTypography ref={ref} {...rest}>
        {children}
      </MuiTypography>
    );
  }
);

Typography.displayName = 'Typography';

export default Typography;
